module.exports = __webpack_public_path__ + "img/keyboard.3ced67b3.png";